__turbopack_context__.v({
  "row": "Row-module-scss-module__VPFa9a__row",
  "values": "Row-module-scss-module__VPFa9a__values",
});
